import React from "react";
import { func, bool } from "prop-types";
import Button from "pages/_components/Button";
import * as i18nUtils from "util/i18n";

const PaywayTitle = ({ handleHelp, isDesktop }) => (
    <>
        <div className="payway-title-container">
            <div className="payway-title-wrapper">
                {isDesktop ? (
                    <h1 className="text-center">
                        {i18nUtils.get("onboarding.stepPayway.text1", "Acreditá tus ventas con BIBANK")}
                    </h1>
                ) : (
                    <h2 className="text-right">
                        {i18nUtils.get("onboarding.stepPayway.text1", "Acreditá tus ventas con BIBANK")}
                    </h2>
                )}
                <Button
                    className="head__icon-button"
                    bsStyle="link"
                    image="images/figma/icon/help.svg"
                    block={false}
                    onClick={handleHelp}
                />
            </div>
        </div>
        <h4 className="text-center">
            {i18nUtils.get(
                "onboarding.stepPayway.text2",
                "¡Agilizá tus cobros y potenciá tu empresa con la solución que estabas esperando!",
            )}
        </h4>
        <div className="py-3" />
    </>
);

PaywayTitle.propTypes = {
    isDesktop: bool.isRequired,
    handleHelp: func.isRequired,
};

export default PaywayTitle;
